// Service for patient-specific bulk tagging
// Endpoint: patients/<patient_id>/tags/bulk/

import { useMutation } from "react-query";
import servicesUtils from "../../../utils/servicesUtils";
var usePatientBulkTaggingService = function usePatientBulkTaggingService(patientId) {
  return useMutation(function (data) {
    return servicesUtils.postService("/patients/".concat(patientId, "/tags/bulk/"), data);
  });
};
export default usePatientBulkTaggingService;